/* Fun Cases personaliser — canvas editor (Fabric.js, lazy-loaded).
   Model: an ARTBOARD = print area + bleed. Content lives on the artboard; a
   mockup overlay (transparent print window) frames it, so anything spilling off
   the case is captured as bleed. Fabric loads only when the editor first opens.

   Config (per product) comes from window.__fcPersonalise:
     { productFormSelector, fabricUrl, aspect, bleed, mockup, radius,
       fonts:[], colours:[], stickers:[] }
   Left as sensible defaults until real per-product masks/config are wired. */
(function () {
  'use strict';

  var CFG = window.__fcPersonalise || {};
  var AW = 1000;                                   // internal artboard width
  var ASPECT = CFG.aspect || 0.5;                  // print area w/h
  var AH = Math.round(AW / ASPECT);                // internal artboard height
  var MODE = 'overlay';                            // 'overlay' (transparent window) | 'print' (garment behind)
  var PIPE = 'placed';                             // active finish pipeline: 'phone' | 'placed' | 'flat'
  var PRINT = null;                                // print area [x,y,w,h] as fractions of the artboard
  var FRAMEFIT = 0;                                // >0 = scale base design by the composite frame math (case height fraction)
  var baseLoaded = false;                          // standard designs pre-load their AWS artwork once
  var BLEED = CFG.bleed != null ? CFG.bleed : 0.05;
  var RADIUS = CFG.radius != null ? CFG.radius : 0.09; // corner radius (of AW)
  var FONTS = CFG.fonts || ['Fredoka', 'Nunito', 'Le Petit Cochon', 'Georgia', 'Impact', 'Courier New'];
  var COLOURS = CFG.colours || ['#161616', '#ffffff', '#f03e2e', '#ffc933', '#35bdf2', '#58bb46', '#ff7bb2', '#8a4fd3'];
  var STICKERS = CFG.stickers || ['⭐', '❤️', '🌈', '✨', '🌸', '💀', '🍒', '😎', '👑', '🦋', '☀️', '⚡', '🍄', '🎀', '🐾'];

  var modal, canvasEl, fcanvas, fabricReady = false, loadingFabric = false;
  var activeColour = COLOURS[0], activeFont = FONTS[0];
  var history = [], histIdx = -1, restoring = false;
  var introShown = false;
  var designAttached = false;

  /* ---------- open / close ---------- */
  function open() {
    if (!modal) build();
    document.body.classList.add('pz-lock');
    modal.classList.add('is-open');
    modal.classList.toggle('pz--phone', !!(CFG.isPhone && CFG.baseDesignRaw));
    if (!introShown) { var iv = modal.querySelector('[data-pz-intro]'); if (iv) iv.hidden = false; }
    ensureFabric(function () {
      if (!fcanvas) initCanvas(); else applyEntry();
      // Desktop opens with a tool panel showing in the right rail; mobile stays clean.
      if (window.innerWidth >= 900) switchTab('photo');
      fitBoard();
      hint('Tap a tool to start');
    });
  }
  function close() { if (!modal) return; modal.classList.remove('is-open'); document.body.classList.remove('pz-lock'); }

  /* ---------- lazy-load fabric ---------- */
  function ensureFabric(cb) {
    if (fabricReady && window.fabric) return cb();
    if (loadingFabric) { var t = setInterval(function () { if (window.fabric) { clearInterval(t); fabricReady = true; cb(); } }, 60); return; }
    loadingFabric = true;
    var s = document.createElement('script');
    s.src = CFG.fabricUrl;
    s.onload = function () { fabricReady = true; cb(); };
    s.onerror = function () { loading(false); alert('Could not load the designer. Please refresh and try again.'); };
    document.head.appendChild(s);
  }

  /* ---------- build DOM ---------- */
  function icon(paths) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + paths + '</svg>';
  }
  function build() {
    modal = document.createElement('div');
    modal.className = 'pz';
    modal.innerHTML =
      '<div class="pz__inner">' +
        '<div class="pz__top">' +
          '<button class="pz__x" data-pz-close aria-label="Close">' + icon('<path d="M6 6l12 12M18 6L6 18"/>') + '</button>' +
          '<div class="pz__title">Make it yours</div>' +
          '<div class="pz__undo">' +
            '<button class="pz__iconbtn" data-pz-undo aria-label="Undo" disabled>' + icon('<path d="M9 14 4 9l5-5"/><path d="M4 9h11a5 5 0 0 1 0 10h-3"/>') + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="pz__stage">' +
          '<div class="pz__obj" data-pz-objbar>' +
            '<button data-pz-forward aria-label="Bring forward">' + icon('<path d="M12 5v14M5 12l7-7 7 7"/>') + '</button>' +
            '<button data-pz-dup aria-label="Duplicate">' + icon('<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/>') + '</button>' +
            '<button class="danger" data-pz-del aria-label="Delete">' + icon('<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/>') + '</button>' +
          '</div>' +
          '<div class="pz__board"><canvas data-pz-canvas></canvas></div>' +
          '<div class="pz__hint" data-pz-hint></div>' +
          '<div class="pz__loading" data-pz-loading><span class="pz__spin"></span><span class="pz__loadmsg" data-pz-loadmsg></span></div>' +
        '</div>' +
        '<div class="pz__controls">' +
        '<div class="pz__panels">' +
          '<div class="pz__panel" data-pz-panel="photo">' +
            '<label class="pz-upload"><span class="pz-upload__ico">📷</span><b>Upload a photo</b><span>JPG or PNG, up to 15MB</span>' +
              '<input type="file" accept="image/*" data-pz-file></label>' +
          '</div>' +
          '<div class="pz__panel" data-pz-panel="text">' +
            '<div class="pz__field"><input type="text" placeholder="Type here…" data-pz-text maxlength="60"><button class="pz__add" data-pz-addtext>Add</button></div>' +
            '<div class="pz__row"><span class="lbl">Font</span><div class="pz-fonts" data-pz-fonts></div></div>' +
            '<div class="pz__row"><span class="lbl">Colour</span><div class="pz-swatches" data-pz-swatches></div></div>' +
          '</div>' +
          '<div class="pz__panel" data-pz-panel="stickers">' +
            '<div class="pz-stickers" data-pz-stickers></div>' +
          '</div>' +
        '</div>' +
        '<div class="pz__bar">' +
          '<button class="pz-tab" data-pz-tab="photo">' + icon('<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="9" cy="11" r="2"/><path d="m21 17-5-5-8 7"/>') + '<span>Photo</span></button>' +
          '<button class="pz-tab" data-pz-tab="text">' + icon('<path d="M4 7V5h16v2M9 5v14M7 19h4"/>') + '<span>Text</span></button>' +
          '<button class="pz-tab" data-pz-tab="stickers">' + icon('<path d="M15 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9l7-7V5a2 2 0 0 0-2-2Z"/><path d="M14 21v-5a2 2 0 0 1 2-2h5"/>') + '<span>Stickers</span></button>' +
          '<button class="pz-done" data-pz-done>Done</button>' +
        '</div>' +
        '</div>' +
        '<div class="pz__intro" data-pz-intro hidden>' +
          '<div class="pz__intro-card">' +
            '<div class="pz__intro-spark">✨</div>' +
            '<h3>Before you start</h3>' +
            '<ul class="pz__intro-list">' +
              '<li><span>📐</span><p><b>Keep the important bits away from the edges.</b> Printing can shift a millimetre or two, so faces, text and logos near the border may get trimmed.</p></li>' +
              '<li><span>🎁</span><p><b>Personalised items are made just for you</b>, so they can\'t be returned or refunded. Give your design a good look before you add to bag.</p></li>' +
              '<li><span>🛒</span><p><b>Your design is only saved once you add to bag.</b> If you change your phone or options beforehand, the design will reset — so finish designing, then add to bag.</p></li>' +
            '</ul>' +
            '<button type="button" class="pz__intro-ok" data-pz-intro-ok>Got it — let\'s design</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    // populate swatches / fonts / stickers
    var sw = modal.querySelector('[data-pz-swatches]');
    COLOURS.forEach(function (c, i) {
      var b = document.createElement('button');
      b.className = 'pz-sw' + (i === 0 ? ' is-active' : ''); b.style.background = c; b.dataset.col = c;
      sw.appendChild(b);
    });
    var fw = modal.querySelector('[data-pz-fonts]');
    FONTS.forEach(function (f, i) {
      var b = document.createElement('button');
      b.className = 'pz-font' + (i === 0 ? ' is-active' : ''); b.textContent = f.replace(/'/g, ''); b.style.fontFamily = f; b.dataset.font = f;
      fw.appendChild(b);
    });
    var stk = modal.querySelector('[data-pz-stickers]');
    STICKERS.forEach(function (s) {
      var b = document.createElement('button');
      b.className = 'pz-sticker'; b.textContent = s; b.dataset.sticker = s;
      stk.appendChild(b);
    });

    canvasEl = modal.querySelector('[data-pz-canvas]');
    wireEvents();
  }

  function loading(on, msg) { var el = modal && modal.querySelector('[data-pz-loading]'); if (!el) return; el.style.display = on ? 'flex' : 'none'; var m = el.querySelector('[data-pz-loadmsg]'); if (m) m.textContent = on && msg ? msg : ''; }
  function hint(msg) { var el = modal.querySelector('[data-pz-hint]'); if (!el) return; el.textContent = msg; el.classList.add('show'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('show'); }, 2200); }

  /* ---------- canvas ---------- */
  function initCanvas() {
    fcanvas = new fabric.Canvas(canvasEl, { selection: true, preserveObjectStacking: true, backgroundColor: '#ffffff' });
    fabric.Object.prototype.set({ cornerColor: '#161616', cornerStyle: 'circle', cornerSize: 22, touchCornerSize: 40, transparentCorners: false, borderColor: '#35bdf2', borderScaleFactor: 2, padding: 4 });

    applyEntry();

    fcanvas.on('selection:created', updateObjBar);
    fcanvas.on('selection:updated', updateObjBar);
    fcanvas.on('selection:cleared', updateObjBar);
    fcanvas.on('object:moving', constrainObj);
    fcanvas.on('object:modified', snapshot);
    enablePinchScale();
    snapshot();
  }
  // Two-finger pinch to resize the selected element on touch devices (the corner handles are
  // fiddly on a phone). Scales the active object only — never the canvas viewport, so exports
  // are unaffected. No-op with nothing selected or on the locked base design.
  function enablePinchScale() {
    var el = fcanvas && fcanvas.upperCanvasEl; if (!el) return;
    var startDist = 0, startScale = 1, target = null;
    function d(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.sqrt(dx * dx + dy * dy); }
    el.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 2) return;
      var o = fcanvas.getActiveObject();
      if (o && !o._pzBase && !o._pzGuide) { target = o; startDist = d(e.touches); startScale = o.scaleX || 1; o.lockMovementX = o.lockMovementY = true; }
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (!target || e.touches.length !== 2 || !startDist) return;
      e.preventDefault();
      var s = Math.max(0.05, Math.min(startScale * (d(e.touches) / startDist), 8));
      target.scale(s); target.setCoords(); fcanvas.requestRenderAll();
    }, { passive: false });
    function endPinch(e) {
      if (e.touches && e.touches.length >= 2) return;
      if (target) { target.lockMovementX = target.lockMovementY = false; snapshot(); }
      target = null; startDist = 0;
    }
    el.addEventListener('touchend', endPinch);
    el.addEventListener('touchcancel', endPinch);
  }

  // The print-area rectangle in artboard pixels (from PRINT fractions, else full board minus bleed).
  function printRectPx() {
    if (PRINT) return { left: AW * PRINT[0], top: AH * PRINT[1], width: AW * PRINT[2], height: AH * PRINT[3] };
    var bx = AW * BLEED, by = AH * BLEED;
    return { left: bx, top: by, width: AW - bx * 2, height: AH - by * 2 };
  }
  // Draw the guide: dashed rounded trim for overlay (phone), a solid print box for print mode (garment).
  function drawGuides() {
    fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (o) { fcanvas.remove(o); });
    // Phones: the case itself is the boundary (the view is cropped to it), so no dashed guide.
    // (Custom/Design-Your-Own phones have no baseDesignRaw but are still phones — the case mockup
    // is the boundary, so they must NOT get the stray dashed trim either.)
    if (CFG.isPhone) return;
    var p = printRectPx();
    var guide = new fabric.Rect({
      left: p.left, top: p.top, width: p.width, height: p.height,
      rx: MODE === 'print' ? 4 : AW * RADIUS, ry: MODE === 'print' ? 4 : AW * RADIUS,
      fill: MODE === 'print' ? 'rgba(88,187,70,0.05)' : 'rgba(53,189,242,0.04)',
      stroke: MODE === 'print' ? 'rgba(22,22,22,0.6)' : 'rgba(22,22,22,0.45)',
      strokeDashArray: MODE === 'print' ? [8, 6] : [10, 8], strokeWidth: 2,
      selectable: false, evented: false, excludeFromExport: true
    });
    guide._pzGuide = true;
    fcanvas.add(guide); fcanvas.sendToBack(guide);
  }
  // Clip a design object to the print area so nothing renders (or prints) outside it.
  // Applies to garments (print mode) AND phones (overlay with a case print rect).
  function clipObj(o) {
    if (!PRINT) return;
    var p = printRectPx();
    o.clipPath = new fabric.Rect({ left: p.left, top: p.top, width: p.width, height: p.height, absolutePositioned: true });
  }
  // Keep a dragged object's centre inside the print area so it can't be lost off the case.
  function constrainObj(e) {
    if (!PRINT) return;
    var o = e.target; if (!o || o._pzGuide) return;
    var p = printRectPx();
    if (o.originX === 'center' && o.originY === 'center') {
      o.left = Math.max(p.left, Math.min(p.left + p.width, o.left));
      o.top = Math.max(p.top, Math.min(p.top + p.height, o.top));
    }
  }

  /* ---------- mockup (from the global map) ---------- */
  function firstVal(o) { for (var k in o) { if (o.hasOwnProperty(k)) return o[k]; } return null; }
  function currentSide() {
    var r = document.querySelector('input[name="properties[Colour Sides]"]:checked');
    if (r && r.getAttribute('data-side')) return r.getAttribute('data-side');
    return (CFG.colourSide || 'black');
  }
  // Every value currently selected on the PDP (colour sides + all variant options),
  // lowercased, so a mockup keyed by a variant dimension (colour / shape / metal) can be matched.
  function currentSelections() {
    var out = [];
    var cs = document.querySelector('input[name="properties[Colour Sides]"]:checked');
    if (cs && cs.value) out.push(cs.value.toLowerCase().trim());
    document.querySelectorAll('.pdp-option input:checked').forEach(function (c) {
      if (c.value) out.push(c.value.toLowerCase().trim());
    });
    return out;
  }
  function norm(leaf) {
    if (!leaf) return null;
    if (typeof leaf === 'string') return { url: leaf, mode: 'overlay', print: null };
    // 'placed' = spreadsheet-driven: render the design through the recipe transforms (mockup at
    // opacity 0 sets the frame) so the design lands at the exact size/position, then overlay the mockup.
    if (leaf.mode === 'placed') return { mode: 'placed', baseTransform: leaf.baseTransform, mockupLayer: leaf.mockupLayer, layerFx: leaf.layerFx || null, print: leaf.print || null };
    // 'flat' = clothing/drinkware: a plain artboard (ratio) the customer designs on; on Done the
    // artwork is uploaded and composited onto the garment/drinkware via the product recipe.
    if (leaf.mode === 'flat') return { mode: 'flat', ratio: leaf.ratio || 0.7071, preview: leaf.preview };
    if (typeof leaf.url !== 'string') return null;
    return { url: leaf.url, mode: leaf.mode || 'overlay', print: leaf.print || null, frameFit: leaf.frameFit || null };
  }
  // Config passes the product-TYPE subtree; resolve it to one { url, mode, print }.
  // Either a direct entry, or keyed by a variant value we match against the current selections.
  // Live blank from the CURRENTLY selected PDP variant's Cloudinary composite (phone
  // cases). Reads the same [data-pdp-cloud] map the product image uses, extracts the
  // baked-in case layer, and renders it alone on a transparent 1000² canvas — so the
  // popup always matches the live model + case type + colour, with no page-load staleness.
  function liveEntry() {
    if (!CFG.isPhone) return null;
    var idEl = document.querySelector('[data-pdp-variant-id]');
    var cloudEl = document.querySelector('[data-pdp-cloud]');
    if (!idEl || !cloudEl) return null;
    var cloud; try { cloud = JSON.parse(cloudEl.textContent); } catch (e) { return null; }
    var ent = cloud[idEl.value]; if (!ent) return null;
    var side = currentSide();
    var comp = ent[side] || ent.black || ent.clear || ent.white;
    if (!comp || comp.indexOf('/l_') < 0) return null;
    var lid = comp.split('/l_')[1].split(',')[0];
    if (!lid) return null;
    // e_trim crops the case to its tight phone bounds so it FILLS the editor box. frameFit:0.94
    // tells the base-design loader to scale the artwork by the composite's frame math (design
    // contained in a 1000² frame, case at h_940) so placement still matches Cloudinary exactly.
    return { url: 'https://res.cloudinary.com/dpuznvkgc/image/upload/e_trim/f_png/' + lid, mode: 'overlay', print: CFG.phonePrint || null, frameFit: 0.94 };
  }
  // Resolve just the metafield entry (type → colour/shape/metal), without the live phone composite.
  function resolveMockupEntry() {
    var m = CFG.mockups;
    if (!m) return CFG.mockup ? { url: CFG.mockup, mode: 'overlay', print: null } : null;
    if (typeof m === 'string') return { url: m, mode: 'overlay', print: null };
    if (typeof m.url === 'string' || typeof m.mode === 'string') return norm(m);  // direct entry
    var sel = currentSelections(), keys = Object.keys(m);
    for (var i = 0; i < keys.length; i++) {
      if (sel.indexOf(keys[i].toLowerCase().trim()) > -1) return norm(m[keys[i]]);   // match colour / shape / metal
    }
    var byType = m.Standard || firstVal(m);
    if (byType && typeof byType === 'object' && typeof byType.url !== 'string' && typeof byType.mode !== 'string') {
      var side = currentSide(), cap = side.charAt(0).toUpperCase() + side.slice(1);
      var leaf = byType[cap] || byType[side]; if (leaf) return norm(leaf);
    }
    return norm(firstVal(m));
  }
  // Per-model print-area aspect (width/height) for WOYC Tough / MagSafe Tough, from the Printify
  // catalog. Used so the DYO artboard matches the case's real print area → the design maps 1:1 onto
  // the case (no crop/margin) instead of the generic 0.5. Regenerate if WOYC changes the blueprints.
  var DYO_ASPECTS = {"tough":{"iPhone 17":0.5971,"iPhone 17 Air":0.5942,"iPhone 17 Pro":0.5988,"iPhone 17 Pro Max":0.5886,"iPhone 16":0.5976,"iPhone 16 Plus":0.6053,"iPhone 16 Pro":0.5976,"iPhone 16 Pro Max":0.6053,"iPhone 15":0.5976,"iPhone 15 Plus":0.6053,"iPhone 15 Pro":0.5976,"iPhone 15 Pro Max":0.6053,"iPhone 14":0.6251,"iPhone 14 Plus":0.6075,"iPhone 14 Pro":0.6262,"iPhone 14 Pro Max":0.6067,"iPhone 13":0.607,"iPhone 13 Pro":0.607,"iPhone 13 Pro Max":0.5959,"iPhone 13 Mini":0.6128,"iPhone 12 Pro Max":0.5959,"iPhone 12 Mini":0.6128,"iPhone 11":0.6263,"iPhone 11 Pro":0.6174,"iPhone 11 Pro Max":0.5978,"iPhone XS Max":0.6177,"iPhone XR":0.6276,"Galaxy S26":0.598,"Galaxy S26 Plus":0.5921,"Galaxy S26 Ultra":0.5884,"Galaxy S25":0.5966,"Galaxy S25 Plus":0.589,"Galaxy S25 Ultra":0.6056,"Galaxy S24":0.5966,"Galaxy S24 Plus":0.589,"Galaxy S24 Ultra":0.5941,"Galaxy S23":0.606,"Galaxy S23 Plus":0.6014,"Galaxy S23 Ultra":0.5946,"Galaxy S22":0.6046,"Galaxy S22 Plus":0.5945,"Galaxy S22 Ultra":0.5833,"Galaxy S21":0.5796,"Galaxy S21 Plus":0.5689,"Galaxy S21 Ultra":0.552,"Galaxy S21FE":0.5794,"Galaxy S20":0.5504,"Galaxy S20 Plus":0.5472,"Galaxy S20FE":0.5808,"Google Pixel 9 Pro XL":0.6056,"Google Pixel 8":0.5851,"Google Pixel 8 Pro":0.5847,"Google Pixel 7":0.5902,"Google Pixel 6":0.5762,"iPhone 12 / 12 Pro":0.607,"iPhone X / XS":0.6245,"iPhone 6 / 7 / 8 / SE":0.6217,"Google Pixel 9 / 9 Pro":0.6251},"magtough":{"iPhone 17":0.5971,"iPhone 17 Air":0.5942,"iPhone 17 Pro":0.5988,"iPhone 17 Pro Max":0.5886,"iPhone 16":0.5976,"iPhone 16 Plus":0.6053,"iPhone 16 Pro":0.5976,"iPhone 16 Pro Max":0.6053,"iPhone 15":0.5976,"iPhone 15 Plus":0.6053,"iPhone 15 Pro":0.5976,"iPhone 15 Pro Max":0.6053,"iPhone 14":0.5976,"iPhone 14 Plus":0.6052,"iPhone 14 Pro":0.5976,"iPhone 14 Pro Max":0.6052,"iPhone 13":0.607,"iPhone 13 Pro":0.607,"iPhone 13 Pro Max":0.5959}};
  function dyoCaseKey() { return /magsafe/i.test(selectedCaseType()) ? 'magtough' : 'tough'; }
  function dyoAspect() { return (DYO_ASPECTS[dyoCaseKey()] || {})[CFG.model] || 0.6; }
  // The currently selected Case Type value on the PDP (pdp-ct tiles or a plain option group).
  function selectedCaseType() {
    var el = document.querySelector('[data-pdp-ct] input:checked');
    if (!el) {
      var groups = [].slice.call(document.querySelectorAll('[data-pdp-options] .pdp-option'));
      for (var i = 0; i < groups.length; i++) {
        var lbl = groups[i].querySelector('.pdp-option__label');
        if (lbl && /case type/i.test(lbl.textContent)) { el = groups[i].querySelector('input:checked'); break; }
      }
    }
    return el ? (el.value || '').trim() : '';
  }
  // Outsourced case types (Printify/WOYC) — no in-house live composite exists for them.
  function isOutsourcedCase() { return /^(tough|snap|magsafe tough)$/i.test(selectedCaseType()); }
  function resolveEntry() {
    // Spreadsheet-driven placed/flat entries win — even on phone-type products like the wallet
    // case (which has a model option but is really a flat overlay, not a live phone composite).
    var entry = resolveMockupEntry();
    if (entry && (entry.mode === 'placed' || entry.mode === 'flat')) return entry;
    var live = liveEntry(); if (live) return live;
    // Custom / Design-Your-Own on an outsourced case type (Tough / MagSafe Tough): a flat blank
    // artboard sized to the case's REAL per-model print-area aspect, so the design maps 1:1 onto
    // the Printify case (no crop/margin). Never the baked Standard mockup (that showed the wrong case).
    if (CFG.isCustom && isOutsourcedCase()) return { mode: 'flat', ratio: dyoAspect() };
    return entry;
  }
  // Apply the resolved entry: set mode/print, size the board (print mode follows the garment aspect),
  // place the image as an OVERLAY (transparent window on top) or BACKGROUND (garment behind).
  function applyEntry() {
    if (!fcanvas) return;
    VIEWCROP = null;
    var entry = resolveEntry();
    // Spreadsheet-driven modes take priority (so the wallet case uses 'placed', not the phone pipeline).
    if (entry && entry.mode === 'flat') { applyFlatEntry(entry); return; }
    if (entry && entry.mode === 'placed') { applyPlacedEntry(entry); return; }
    // Phones use the server-side (Cloudinary) pipeline: design backdrop + case overlay.
    if (CFG.isPhone && CFG.baseDesignRaw) { applyPhoneEntry(); return; }
    // DYO / Custom-Photo, in-house case type (Standard / Standard MagSafe): no base design, so frame it
    // cleanly here. (Outsourced Tough / MagSafe Tough are already handled above via the flat artboard.)
    if (CFG.isCustom && CFG.isPhone) { applyCustomPhoneEntry(); return; }
    PIPE = 'placed';   // generic overlay products finish through finishPlaced
    loading(true);   // keep the spinner up until the mockup is actually on the board
    if (!entry || !entry.url) { MODE = 'overlay'; PRINT = null; fcanvas.setOverlayImage(null, function () {}); fcanvas.setBackgroundImage(null, function () {}); drawGuides(); fcanvas.requestRenderAll(); loading(false); return; }
    MODE = entry.mode; PRINT = entry.print; FRAMEFIT = entry.frameFit || 0;
    fabric.Image.fromURL(entry.url, function (img) {
      if (!img) { drawGuides(); loading(false); return; }
      AH = Math.round(AW / (img.width / img.height));   // artboard follows the mockup for BOTH modes
      img.set({ selectable: false, evented: false }); img.scaleToWidth(AW);
      var after = function () { drawGuides(); loadBaseDesign(); fitBoard(); fcanvas.requestRenderAll(); loading(false); };
      if (MODE === 'print') {
        fcanvas.setOverlayImage(null, function () {});
        fcanvas.setBackgroundImage(img, after);
      } else {
        fcanvas.setBackgroundImage(null, function () {});
        fcanvas.setOverlayImage(img, after);
      }
    }, { crossOrigin: 'anonymous' });
  }
  // 'placed' mode: the base design is pre-placed by Cloudinary using the spreadsheet recipe
  // (mockup at opacity 0 sets the frame → design at the exact size/position). Loaded as a locked
  // base object filling the board, with the real mockup overlaid on top. PRINT = the design's area.
  function applyPlacedEntry(entry) {
    loading(true);
    PIPE = 'placed';
    MODE = 'overlay'; PRINT = entry.print || null; FRAMEFIT = 0; VIEWCROP = null;
    var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
    var fx = entry.layerFx ? ',' + entry.layerFx : '';
    var raw = CFG.baseDesignRaw;
    // Mockup in the SAME frame as the placed design (design made invisible with o_0), so any
    // layer offset stays aligned; fall back to the raw mockup for blank (custom) products.
    var mockupUrl = (raw && entry.baseTransform)
      ? CL + 'image/fetch/' + entry.baseTransform + '/o_0/l_' + entry.mockupLayer + fx + ',fl_layer_apply/f_png/' + raw
      : CL + 'image/upload/f_png/' + entry.mockupLayer;
    fabric.Image.fromURL(mockupUrl, function (mimg) {
      if (mimg && mimg.width) { AH = Math.round(AW / (mimg.width / mimg.height)); mimg.set({ selectable: false, evented: false }); mimg.scaleToWidth(AW); }
      else { AH = AW; }
      fcanvas.setBackgroundImage(null, function () {});
      fcanvas.setOverlayImage(mimg && mimg.width ? mimg : null, function () {
        var finishPlaced = function () {
          drawGuides();
          fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (g) { fcanvas.sendToBack(g); });
          fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot();
        };
        if (CFG.baseDesignRaw && entry.baseTransform) {
          var placedUrl = CL + 'image/fetch/' + entry.baseTransform + '/l_' + entry.mockupLayer + fx + ',o_0,fl_layer_apply/f_png/' + raw;
          fabric.Image.fromURL(placedUrl, function (dimg) {
            if (dimg && dimg.width) {
              var sc = AW / dimg.width;   // the placed design IS the full frame — fill the board 1:1
              dimg.set({ left: 0, top: 0, originX: 'left', originY: 'top', scaleX: sc, scaleY: sc, selectable: false, evented: false });
              dimg._pzBase = true; baseLoaded = true;
              fcanvas.add(dimg); fcanvas.sendToBack(dimg);
            }
            finishPlaced();
          }, { crossOrigin: 'anonymous' });
        } else { baseLoaded = true; finishPlaced(); }
      });
    }, { crossOrigin: 'anonymous' });
  }
  // 'flat' mode (clothing/drinkware): a plain artboard at the product ratio. The base design is
  // contained (fit, never stretched); the customer designs on the flat artwork. No mockup — the
  // garment/drinkware preview is composited by Cloudinary on Done.
  var flatEntry = null;
  function applyFlatEntry(entry) {
    loading(true);
    PIPE = 'flat';
    MODE = 'flat'; PRINT = [0, 0, 1, 1]; FRAMEFIT = 0; VIEWCROP = null; flatEntry = entry;
    AH = Math.round(AW / (entry.ratio || 0.7071));
    fcanvas.setOverlayImage(null, function () {});
    fcanvas.setBackgroundImage(null, function () {});
    var done = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot(); };
    if (CFG.baseDesign) {
      fabric.Image.fromURL(CFG.baseDesign, function (dimg) {
        if (dimg && dimg.width) {
          var scale = Math.min(AW / dimg.width, AH / dimg.height);   // contain — fit whole, centred
          dimg.set({ left: AW / 2, top: AH / 2, originX: 'center', originY: 'center', scaleX: scale, scaleY: scale, selectable: false, evented: false });
          dimg._pzBase = true; baseLoaded = true;
          fcanvas.add(dimg); fcanvas.sendToBack(dimg);
        }
        done();
      }, { crossOrigin: 'anonymous' });
    } else { baseLoaded = true; done(); }
  }
  // Capture the whole flat artboard (base design + additions) transparent, at print resolution.
  function captureArtboard() {
    fcanvas.discardActiveObject();
    var bc = fcanvas.backgroundColor;
    fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    var data = fcanvas.toDataURL({ format: 'png', multiplier: (CFG.exportWidth || 2500) / (AW * z) });
    fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return dataURLtoBlob(data);
  }

  /* ---------- phone pipeline (Cloudinary-composited) ---------- */
  var CASE_LID = null, DESIGN_ASPECT = 0.5, DESIGN_NATIVE_W = 2000, VIEWCROP = null;
  // The e_trim (tight) case URL + its layer id for the current selection.
  function phoneCase() {
    var entry = resolveEntry();
    if (!entry || !entry.url) return null;
    var lid = entry.url.split('/').pop();
    if (!lid) return null;
    return { lid: lid, url: 'https://res.cloudinary.com/dpuznvkgc/image/upload/e_trim/f_png/' + lid };
  }
  // Editor: DESIGN as the backdrop (fills the design-frame board) + the CASE framed to the same
  // 1000² frame the composite uses, placed ON TOP as an overlay. The case's opaque bezel + border
  // therefore COVER anything the customer places outside the printable window (the clipping they
  // expect), while the transparent window shows the design + their additions. Positioning matches
  // the real product composite because both use the identical frame math.
  function applyPhoneEntry() {
    loading(true);
    PIPE = 'phone';
    MODE = 'overlay';
    var pc = phoneCase();
    CASE_LID = pc ? pc.lid : null;
    fabric.Image.fromURL(CFG.baseDesign, function (dimg) {
      if (dimg && dimg.width) { DESIGN_ASPECT = dimg.width / dimg.height; DESIGN_NATIVE_W = dimg.width; }
      else { DESIGN_ASPECT = 0.5; DESIGN_NATIVE_W = 2000; }
      AH = Math.round(AW / DESIGN_ASPECT);
      if (dimg && dimg.width) { dimg.set({ selectable: false, evented: false }); dimg.scaleToWidth(AW); }
      var withCase = function (caseAspect) {
        // Match the SAVED image exactly: the design fills the board, additions live on it (the
        // print), and the case overlay is rendered with the SAME Cloudinary recipe as the composite
        // (design hidden with o_0, case layer applied) — so what the customer designs === what saves.
        // The composite frame is square; the design fills its height, so we show an AH×AH window
        // centred on the design and scale the case so its transparent print window lands on the design.
        PRINT = [0, 0, 1, 1];
        VIEWCROP = { left: (AW - AH) / 2, top: 0, width: AH, height: AH };
        var raw = CFG.baseDesignRaw;
        var render = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); };
        fcanvas.setBackgroundImage(dimg && dimg.width ? dimg : null, function () {
          if (!CASE_LID || !raw) { fcanvas.setOverlayImage(null, render); return; }
          var ovUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/fetch/w_1000,h_1000,c_pad,g_center/o_0/c_scale,h_940/l_' + CASE_LID + ',fl_layer_apply/f_png/' + raw;
          fabric.Image.fromURL(ovUrl, function (oc) {
            if (!oc || !oc.width) { fcanvas.setOverlayImage(null, render); return; }
            var sc = AH / oc.height;   // composite frame (940) → design height (AH); case centres on the design
            oc.set({ selectable: false, evented: false, originX: 'center', originY: 'center', scaleX: sc, scaleY: sc, left: AW / 2, top: AH / 2 });
            fcanvas.setOverlayImage(oc, render);
          }, { crossOrigin: 'anonymous' });
        });
      };
      if (pc) fabric.Image.fromURL(pc.url, function (ci) { withCase(ci && ci.width ? ci.width / ci.height : null); }, { crossOrigin: 'anonymous' });
      else withCase(null);
    }, { crossOrigin: 'anonymous' });
  }
  // DYO / Custom-Photo, in-house case type. Show the case centred in a SQUARE frame (like a standard
  // design's clean square) and crop the export to the case rect. NO view-crop is used, so exportArt
  // crops correctly (same proven path garments use: PRINT set, viewport un-panned).
  function applyCustomPhoneEntry() {
    loading(true);
    PIPE = 'placed';                 // saves through finishPlaced (exportArt) — the proven path
    MODE = 'overlay';
    FRAMEFIT = 0;
    VIEWCROP = null;                 // no view-crop → exportArt's crop origin stays correct
    var pc = phoneCase();
    CASE_LID = pc ? pc.lid : null;
    var render = function () { drawGuides(); fitBoard(); fcanvas.requestRenderAll(); loading(false); snapshot(); };
    if (!CASE_LID) { AH = Math.round(AW / (CFG.aspect || 0.5)); PRINT = null; fcanvas.setBackgroundImage(null, function () {}); fcanvas.setOverlayImage(null, render); return; }
    // Measure the tight (e_trim) case aspect, then centre it in a square. c_pad puts a tall case at
    // [(1-ar)/2, 0, ar, 1] of the square, so PRINT = the case rect → the export is the case front.
    fabric.Image.fromURL(pc.url, function (ci) {
      var caseAR = (ci && ci.width && ci.height) ? (ci.width / ci.height) : 0.5;
      if (caseAR > 1) caseAR = 1;
      AH = AW;                                       // square board
      PRINT = [(1 - caseAR) / 2, 0, caseAR, 1];      // case rect within the square = the print area
      var ovUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/e_trim/w_1000,h_1000,c_pad,g_center/f_png/' + CASE_LID;
      fabric.Image.fromURL(ovUrl, function (oc) {
        fcanvas.setBackgroundImage(null, function () {
          if (!oc || !oc.width) { fcanvas.setOverlayImage(null, render); return; }
          oc.set({ selectable: false, evented: false }); oc.scaleToWidth(AW);
          fcanvas.setOverlayImage(oc, render);
        });
      }, { crossOrigin: 'anonymous' });
    }, { crossOrigin: 'anonymous' });
  }
  function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bstr.charCodeAt(n);
    return new Blob([u8], { type: mime });
  }
  // Capture ONLY the customer additions (no design, no case, no guides) at the design's native
  // resolution, so Cloudinary can overlay them 1:1 on the real artwork.
  function captureAdditions() {
    fcanvas.discardActiveObject();
    var bg = fcanvas.backgroundImage, ov = fcanvas.overlayImage, bc = fcanvas.backgroundColor;
    // Drop the design/case AND the white canvas fill so the additions PNG is TRANSPARENT
    // (otherwise it would cover the design with white when Cloudinary overlays it).
    fcanvas.backgroundImage = null; fcanvas.overlayImage = null; fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    // Temporarily map the FULL design frame 1:1 at native resolution (ignore the view crop),
    // so the additions land in the same frame Cloudinary composites onto.
    var savedVT = fcanvas.viewportTransform.slice(), savedW = fcanvas.getWidth(), savedH = fcanvas.getHeight();
    var s = DESIGN_NATIVE_W / AW;
    fcanvas.setDimensions({ width: Math.round(AW * s), height: Math.round(AH * s) });
    fcanvas.setViewportTransform([s, 0, 0, s, 0, 0]);
    var data = fcanvas.toDataURL({ format: 'png' });
    fcanvas.setViewportTransform(savedVT); fcanvas.setDimensions({ width: savedW, height: savedH });
    fcanvas.backgroundImage = bg; fcanvas.overlayImage = ov; fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return dataURLtoBlob(data);
  }
  function uploadAdditions(blob) {
    var fd = new FormData();
    fd.append('file', blob);
    fd.append('upload_preset', CFG.uploadPreset);
    return fetch('https://api.cloudinary.com/v1_1/' + CFG.cloudName + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (!d.public_id) throw new Error('upload failed'); return d.public_id; });
  }
  // Build the two Cloudinary URLs from the uploaded additions layer (folder slashes → colons).
  function buildPhoneUrls(publicId) {
    var base = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/fetch/';
    var add = publicId.replace(/\//g, ':');
    var design = CFG.baseDesignRaw;
    var regionW = Math.round(1000 * DESIGN_ASPECT);
    // Print file: additions overlaid on the design at full relative width — this IS the artwork.
    var print = base + 'l_' + add + ',fl_relative,w_1.0,fl_layer_apply/' + design;
    // Preview: the framing MUST lead with c_pad (padding the design into the square product frame);
    // baking the additions before the frame collapses it. So pad the design, overlay the additions
    // in the same region, scale to the case window, apply the case. f_png keeps the surround
    // transparent so there's no white border in the gallery.
    var preview = CASE_LID
      ? base + 'w_1000,h_1000,c_pad,g_center/l_' + add + ',w_' + regionW + ',fl_layer_apply/c_scale,h_940/l_' + CASE_LID + ',fl_layer_apply/f_png/' + design
      : print;
    return { print: print, preview: preview };
  }

  // Standard designs: drop the existing AWS artwork in as a locked base layer for the customer to add to.
  function loadBaseDesign() {
    if (baseLoaded || !CFG.baseDesign) return;
    baseLoaded = true;
    fabric.Image.fromURL(CFG.baseDesign, function (img) {
      if (!img) return;
      var cx = AW / 2, cy = AH / 2, scale;
      if (FRAMEFIT && MODE === 'overlay') {
        // Board is the tight (e_trim) case. The composite contains the design in a 1000² frame
        // with the case at h_(FRAMEFIT*1000); reproduce that scale relative to the case bounds
        // so the artwork sits exactly as Cloudinary places it while the case fills the box.
        var FRAME = 1000, CH = FRAMEFIT * FRAME;
        var dA = img.width / img.height;
        var dFrameW = dA >= 1 ? FRAME : FRAME * dA;      // design width when contained in the frame
        var phoneFrameW = CH * (AW / AH);                // case width within that frame
        scale = (dFrameW * (AW / phoneFrameW)) / img.width;
      } else {
        // Garments (print rect) COVER their rect; other overlay products CONTAIN the board.
        var area = PRINT ? printRectPx() : { left: 0, top: 0, width: AW, height: AH };
        cx = area.left + area.width / 2; cy = area.top + area.height / 2;
        scale = PRINT ? Math.max(area.width / img.width, area.height / img.height)
                      : Math.min(area.width / img.width, area.height / img.height);
      }
      img.set({ left: cx, top: cy, originX: 'center', originY: 'center', scaleX: scale, scaleY: scale, selectable: false, evented: false });
      img._pzBase = true;
      if (MODE === 'print') clipObj(img);
      fcanvas.add(img);
      fcanvas.sendToBack(img);   // above the background, below user additions…
      fcanvas.getObjects().filter(function (o) { return o._pzGuide; }).forEach(function (g) { fcanvas.sendToBack(g); }); // …but the guide stays at the very back
      fcanvas.requestRenderAll();
      snapshot();
    }, { crossOrigin: 'anonymous' });
  }

  function fitBoard() {
    if (!fcanvas) return;
    var stage = modal.querySelector('.pz__stage');
    var availW = stage.clientWidth - 32, availH = stage.clientHeight - 32;
    // Fit the crop rect (phone = case bounds) if set, else the whole board.
    var vw = VIEWCROP ? VIEWCROP.width : AW, vh = VIEWCROP ? VIEWCROP.height : AH;
    var scale = Math.min(availW / vw, availH / vh);
    if (!isFinite(scale) || scale <= 0) scale = 0.3;
    fcanvas.setDimensions({ width: Math.round(vw * scale), height: Math.round(vh * scale) });
    var ox = VIEWCROP ? -VIEWCROP.left * scale : 0, oy = VIEWCROP ? -VIEWCROP.top * scale : 0;
    fcanvas.setViewportTransform([scale, 0, 0, scale, ox, oy]);
    fcanvas.requestRenderAll();
  }

  /* ---------- history (simple) ---------- */
  function snapshot() {
    if (restoring) return;
    var json = JSON.stringify(fcanvas.toDatalessJSON());
    history = history.slice(0, histIdx + 1);
    history.push(json); histIdx = history.length - 1;
    var u = modal.querySelector('[data-pz-undo]'); if (u) u.disabled = histIdx <= 0;
  }
  function undo() {
    if (histIdx <= 0) return;
    histIdx--; restoring = true;
    fcanvas.loadFromJSON(history[histIdx], function () {
      // re-draw guides (excluded from export/dataless) if lost
      if (!fcanvas.getObjects().some(function (o) { return o._pzGuide; })) drawGuides();
      // Phones keep the design as a background (not a _pzBase object), so skip the reload there.
      if (CFG.baseDesign && !(CFG.isPhone && CFG.baseDesignRaw) && !fcanvas.getObjects().some(function (o) { return o._pzBase; })) { baseLoaded = false; loadBaseDesign(); }
      fcanvas.requestRenderAll(); restoring = false;
      var u = modal.querySelector('[data-pz-undo]'); if (u) u.disabled = histIdx <= 0;
    });
  }

  /* ---------- object helpers ---------- */
  function centreish() { var p = printRectPx(); return { left: p.left + p.width / 2, top: p.top + p.height / 2, originX: 'center', originY: 'center' }; }
  function pw() { return printRectPx().width; }   // scale new elements to the print area, not the whole board
  function addText(str) {
    var t = new fabric.Textbox(str || 'Your text', Object.assign(centreish(), {
      fontFamily: activeFont, fill: activeColour, fontSize: pw() * 0.14, fontWeight: '700', textAlign: 'center', width: pw() * 0.8
    }));
    clipObj(t);
    fcanvas.add(t); fcanvas.setActiveObject(t); fcanvas.requestRenderAll(); snapshot();
    hint('Drag to move · pinch or corner to resize');
  }
  function addSticker(ch) {
    var t = new fabric.Text(ch, Object.assign(centreish(), { fontSize: pw() * 0.28 }));
    clipObj(t);
    fcanvas.add(t); fcanvas.setActiveObject(t); fcanvas.requestRenderAll(); snapshot();
  }
  function addImage(dataUrl) {
    fabric.Image.fromURL(dataUrl, function (img) {
      var target = pw() * 0.8;
      img.scaleToWidth(target);
      img.set(centreish());
      clipObj(img);
      fcanvas.add(img); fcanvas.setActiveObject(img); fcanvas.requestRenderAll(); snapshot();
      hint(MODE === 'print' ? 'Keep it inside the print area' : 'Fill the case — a little overhang prints as bleed');
    });
  }

  function updateObjBar() {
    var bar = modal.querySelector('[data-pz-objbar]');
    var o = fcanvas && fcanvas.getActiveObject();
    if (o && !o._pzGuide) bar.classList.add('show'); else bar.classList.remove('show');
  }

  /* ---------- events ---------- */
  function wireEvents() {
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-close]')) return close();
      if (e.target.closest('[data-pz-intro-ok]')) { introShown = true; var iv = modal.querySelector('[data-pz-intro]'); if (iv) iv.hidden = true; return; }
      var tab = e.target.closest('[data-pz-tab]');
      if (tab) { switchTab(tab.dataset.pzTab); return; }
      if (e.target.closest('[data-pz-addtext]')) { var inp = modal.querySelector('[data-pz-text]'); addText(inp.value || 'Your text'); inp.value = ''; return; }
      var font = e.target.closest('[data-pz-fonts] .pz-font');
      if (font) { activeFont = font.dataset.font; modal.querySelectorAll('.pz-font').forEach(function (b) { b.classList.remove('is-active'); }); font.classList.add('is-active'); applyToActive('fontFamily', activeFont); return; }
      var sw = e.target.closest('.pz-sw');
      if (sw) { activeColour = sw.dataset.col; modal.querySelectorAll('.pz-sw').forEach(function (b) { b.classList.remove('is-active'); }); sw.classList.add('is-active'); applyToActive('fill', activeColour); return; }
      var st = e.target.closest('.pz-sticker');
      if (st) { addSticker(st.dataset.sticker); return; }
      if (e.target.closest('[data-pz-del]')) { var a = fcanvas.getActiveObject(); if (a) { fcanvas.remove(a); fcanvas.discardActiveObject(); fcanvas.requestRenderAll(); updateObjBar(); snapshot(); } return; }
      if (e.target.closest('[data-pz-dup]')) { var d = fcanvas.getActiveObject(); if (d) d.clone(function (c) { c.set({ left: d.left + 24, top: d.top + 24 }); fcanvas.add(c); fcanvas.setActiveObject(c); fcanvas.requestRenderAll(); snapshot(); }); return; }
      if (e.target.closest('[data-pz-forward]')) { var f = fcanvas.getActiveObject(); if (f) { fcanvas.bringForward(f); fcanvas.requestRenderAll(); snapshot(); } return; }
      if (e.target.closest('[data-pz-undo]')) { undo(); return; }
      if (e.target.closest('[data-pz-done]')) { finish(e.target.closest('[data-pz-done]')); return; }
    });

    modal.addEventListener('change', function (e) {
      var f = e.target.closest('[data-pz-file]');
      if (f && f.files && f.files[0]) {
        var file = f.files[0];
        if (file.size > 15 * 1024 * 1024) { hint('That image is over 15MB — try a smaller one'); f.value = ''; return; }
        var rd = new FileReader();
        rd.onload = function (ev) { addImage(ev.target.result); f.value = ''; };
        rd.readAsDataURL(file);
      }
    });

    // live-apply text input to a selected textbox
    var tinp = modal.querySelector('[data-pz-text]');
    tinp.addEventListener('input', function () {
      var a = fcanvas && fcanvas.getActiveObject();
      if (a && a.type === 'textbox') { a.set('text', tinp.value); fcanvas.requestRenderAll(); }
    });

    window.addEventListener('resize', function () { if (modal.classList.contains('is-open')) fitBoard(); });
  }

  function switchTab(name) {
    modal.querySelectorAll('.pz-tab').forEach(function (t) { t.classList.toggle('is-active', t.dataset.pzTab === name); });
    modal.querySelectorAll('.pz__panel').forEach(function (p) { p.classList.toggle('is-active', p.dataset.pzPanel === name); });
    if (fcanvas) fitBoard();
  }
  function applyToActive(prop, val) {
    var a = fcanvas && fcanvas.getActiveObject();
    if (!a || a._pzGuide) return;
    if (prop === 'fill' && a.type === 'image') return;
    a.set(prop, val); fcanvas.requestRenderAll(); snapshot();
  }

  /* ---------- export + cart hand-off ---------- */
  function exportArt() {
    // The print file is the artwork only — drop the mockup/garment + guides.
    fcanvas.discardActiveObject();
    var savedOverlay = fcanvas.overlayImage, savedBg = fcanvas.backgroundImage;
    fcanvas.overlayImage = null; fcanvas.backgroundImage = null;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    var opts = { format: 'png', multiplier: (CFG.exportWidth || 2000) / (AW * z) };
    if (PRINT) {
      // Crop to the print area (garment print box, or a small overlay window like the FunGrip grip).
      var p = printRectPx();
      opts.left = p.left * z; opts.top = p.top * z; opts.width = p.width * z; opts.height = p.height * z;
    }
    var data = fcanvas.toDataURL(opts);
    fcanvas.overlayImage = savedOverlay; fcanvas.backgroundImage = savedBg;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return data;
  }
  // The print PREVIEW keeps the mockup/garment so the team can see WHERE the design sits.
  function exportPreview() {
    fcanvas.discardActiveObject();
    // Capture on a TRANSPARENT canvas: where the mockup/design don't cover the board (edges,
    // print window) we want transparency, not the canvas's white fill — otherwise a white
    // border bakes into the preview and shows against the (cream) gallery frame.
    var bc = fcanvas.backgroundColor;
    fcanvas.backgroundColor = '';
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = false; });
    var z = fcanvas.getZoom();
    var data = fcanvas.toDataURL({ format: 'png', multiplier: (CFG.previewWidth || 1200) / (AW * z) });
    fcanvas.backgroundColor = bc;
    fcanvas.getObjects().forEach(function (o) { if (o._pzGuide) o.visible = true; });
    fcanvas.requestRenderAll();
    return data;
  }
  function dataURLtoFile(dataurl, name) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8 = new Uint8Array(n);
    while (n--) u8[n] = bstr.charCodeAt(n);
    return new File([u8], name, { type: mime });
  }
  // Attach a data-URL image as a native file line-item property (Shopify uploads it, URL lands on the order).
  function attachFile(form, propName, dataUrl, filename, marker) {
    var input = form.querySelector('input[data-pz-file-marker="' + marker + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'file'; input.name = 'properties[' + propName + ']';
      input.setAttribute('data-pz-file-marker', marker); input.hidden = true;
      form.appendChild(input);
    }
    try {
      var dt = new DataTransfer();
      dt.items.add(dataURLtoFile(dataUrl, filename));
      input.files = dt.files;
      return true;
    } catch (err) { return false; }
  }
  // Swap the PDP main image to the personalised preview so the product shows their design.
  var pdpOriginalSrc = null, pdpOriginalSrcset = null;
  function showOnPdp(src) {
    if (!src) return;
    var img = document.querySelector('[data-pdp-image]');
    if (!img) return;
    if (pdpOriginalSrc === null) { pdpOriginalSrc = img.src; pdpOriginalSrcset = img.getAttribute('srcset'); }
    img.removeAttribute('srcset'); img.src = src;
    // Personalised previews come in the product's OWN aspect (a portrait poster, a tall case…),
    // so let the square gallery frame adapt to the image instead of letterboxing it (no border).
    var frame = img.closest('.pdp-gallery__frame'); if (frame) frame.classList.add('pz-custom');
  }
  // DYO Tough/MagSafe Tough: the DYO gallery is single-image (no thumbs/arrows), so build a
  // self-contained carousel of the Printify mockups — arrows in the frame + a thumbnail strip —
  // reusing the theme's .pdp-gallery__nav / .pdp-thumb styles. Cleaned up on remove.
  var ARROW_SVG = { prev: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>', next: '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' };
  function clearMockupGallery() { document.querySelectorAll('[data-pz-gallery]').forEach(function (el) { el.remove(); }); }
  function showMockupGallery(mockups) {
    mockups = (mockups || []).filter(Boolean);
    if (!mockups.length) return;
    var img = document.querySelector('[data-pdp-image]');
    if (!img) return;
    var frame = img.closest('.pdp-gallery__frame');
    var gallery = img.closest('.pdp-gallery');
    if (pdpOriginalSrc === null) { pdpOriginalSrc = img.src; pdpOriginalSrcset = img.getAttribute('srcset'); }
    clearMockupGallery();
    var idx = 0, strip = null;
    function render() {
      img.removeAttribute('srcset'); img.src = mockups[idx];
      if (frame) frame.classList.add('pz-custom');
      if (strip) [].forEach.call(strip.children, function (b, i) { b.classList.toggle('is-active', i === idx); });
    }
    if (mockups.length > 1 && frame) {
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'pdp-gallery__nav pdp-gallery__nav--' + dir;
        b.setAttribute('data-pz-gallery', 'nav'); b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
        b.innerHTML = ARROW_SVG[dir];
        b.addEventListener('click', function () { idx = dir === 'prev' ? (idx - 1 + mockups.length) % mockups.length : (idx + 1) % mockups.length; render(); });
        frame.appendChild(b);
      });
      if (gallery) {
        strip = document.createElement('div'); strip.className = 'pdp-thumbs'; strip.setAttribute('data-pz-gallery', 'thumbs');
        mockups.forEach(function (u, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pdp-thumb' + (i === 0 ? ' is-active' : ''); b.setAttribute('aria-label', 'View mockup ' + (i + 1));
          b.innerHTML = '<img src="' + u + '" alt="Your case mockup ' + (i + 1) + '" loading="lazy" width="90" height="90">';
          b.addEventListener('click', function () { idx = i; render(); });
          strip.appendChild(b);
        });
        gallery.appendChild(strip);
      }
    }
    render();
  }
  function restorePdp() {
    clearMockupGallery();
    if (pdpOriginalSrc === null) return;
    var img = document.querySelector('[data-pdp-image]');
    if (img) {
      img.src = pdpOriginalSrc; if (pdpOriginalSrcset) img.setAttribute('srcset', pdpOriginalSrcset);
      var frame = img.closest('.pdp-gallery__frame'); if (frame) frame.classList.remove('pz-custom');
    }
    pdpOriginalSrc = null; pdpOriginalSrcset = null;
  }
  // Notify the PDP (e.g. to gate Add to Bag on Design-Your-Own) when a design is attached/removed.
  function emitChange() { try { document.dispatchEvent(new CustomEvent('pz:designchange', { detail: { hasDesign: designAttached } })); } catch (e) {} }
  // Common: hide the trigger, show the ready card, store the flag + property URLs.
  function markReady(form, previewSrc, previewUrl, printUrl, noSwap) {
    if (form) {
      // Underscore-prefixed → stored on the line but hidden from the customer everywhere
      // (cart, checkout, order confirmation + emails). Fulfilment still reads them server-side.
      setHidden(form, '_Your design', previewUrl);
      setHidden(form, '_Print file', printUrl);
      setHidden(form, '_Personalised', 'Yes');
    }
    designAttached = true;
    var trigger = document.querySelector('.pz-open[data-pz-open]');
    if (trigger) trigger.hidden = true;
    var thumb = document.querySelector('[data-pz-preview]');
    if (thumb) {
      thumb.innerHTML = '<img src="' + previewSrc + '" alt="Your design">' +
        '<span class="pz-preview__msg">Your design is ready 🎉</span>' +
        '<button type="button" class="pz-preview__edit" data-pz-open>Edit</button>' +
        '<button type="button" class="pz-preview__remove" data-pz-remove aria-label="Remove design">Remove</button>';
      thumb.hidden = false;
    }
    if (!noSwap) showOnPdp(previewUrl || previewSrc);   // phones skip the PDP image swap — their mockup preview is unreliable
    emitChange();
  }
  // Design-Your-Own on an outsourced case type (Tough / MagSafe Tough): the artwork goes to
  // Printify/WOYC, so we upload the print file, ask the bridge to build a Printify product +
  // generate the on-case mockup, show that mockup, and stash the Printify reference on the line
  // so the order auto-produces. No team review.
  var DYO_PREVIEW_ENDPOINT = 'https://fc-router.vercel.app/api/dyo/preview';
  function finishDyoPrintify(btn) {
    if (btn) btn.classList.add('is-busy');
    var printData = exportArt();   // the customer's artwork, print-ready
    loading(true, 'Creating your case preview…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    var blob;
    try { blob = dataURLtoBlob(printData); } catch (e) { blob = null; }
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (printId) {
      var printUrl = 'https://res.cloudinary.com/' + CFG.cloudName + '/image/upload/' + printId;
      return fetch(DYO_PREVIEW_ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ designUrl: printUrl, model: CFG.model, caseType: selectedCaseType() }),
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j, printUrl: printUrl }; }); });
    }).then(function (res) {
      if (!res.ok || !res.j || res.j.error) throw new Error((res.j && res.j.error) || 'preview failed');
      var form = document.querySelector(CFG.productFormSelector || '[data-pdp-form]');
      var allMockups = (res.j.mockups && res.j.mockups.length) ? res.j.mockups : [res.j.mockup].filter(Boolean);
      var mockup = allMockups[0] || res.printUrl;
      // noSwap:true — the gallery (below) owns the PDP images, not markReady's single swap.
      markReady(form, mockup, mockup, res.printUrl, true);
      showMockupGallery(allMockups);
      if (form) {
        setHidden(form, '_PrintifyProduct', res.j.productId);
        setHidden(form, '_PrintifyVariant', String(res.j.variantId));
      }
      done(); close();
      // Mobile: the editor closes back to wherever the Personalise button was (far down the page),
      // so the customer can't see the mockups just generated — scroll them up to the gallery.
      if (window.innerWidth < 900) {
        var g = document.querySelector('.pdp-gallery');
        if (g) setTimeout(function () { g.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
      }
    }).catch(function (e) {
      alert('Could not create your case preview — please try again.' + (e && e.message ? ' (' + e.message + ')' : ''));
      done();
    });
  }
  function selectedCaseTypeOutsourced() { return CFG.isCustom && isOutsourcedCase(); }
  function finish(btn) {
    // DYO Tough/MagSafe Tough → Printify preview flow (create product + mockup, no team review).
    if (selectedCaseTypeOutsourced()) { finishDyoPrintify(btn); return; }
    // Route by the ACTIVE pipeline, not by isPhone: a phone-type product can still be a 'placed'
    // mockup (e.g. the Wallet Phone Case), which must finish through finishPlaced so its mockup PNG
    // is composited — otherwise it falls back to the raw print with no mockup.
    if (PIPE === 'flat') { finishFlat(btn); return; }
    if (PIPE === 'phone') { finishPhone(btn); return; }
    finishPlaced(btn);
  }
  // Placed (overlay) products: upload the print artwork + the in-context preview so both land on
  // the cart as clean Cloudinary URLs (like phones/flat), instead of base64 file properties.
  function finishPlaced(btn) {
    if (btn) btn.classList.add('is-busy');
    var previewData = exportPreview();   // full editor (design + additions + mockup)
    var printData = exportArt();         // design + additions cropped to the print area
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    var pblob, rblob;
    try { pblob = dataURLtoBlob(previewData); rblob = dataURLtoBlob(printData); } catch (e) { pblob = null; }
    if (!pblob || !rblob) { alert('Could not save your design. Please try again.'); done(); return; }
    Promise.all([uploadAdditions(rblob), uploadAdditions(pblob)]).then(function (ids) {
      var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
      // Phones skip the PDP main-image swap (their tall canvas export would blow up the gallery
      // frame into a giant vertical image) — the design is confirmed via the ready card, exactly
      // like the stock personalised phone cases. Garments/posters still swap so their design shows.
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), previewData, CL + 'image/upload/' + ids[1], CL + 'image/upload/' + ids[0], CFG.isPhone);
      done(); close();
    }).catch(function () { alert('Could not save your design — please check your connection and try again.'); done(); });
  }
  // Phone pipeline: capture the additions → upload to Cloudinary → store the composited URLs.
  function finishPhone(btn) {
    if (btn) btn.classList.add('is-busy');
    var localPreview = exportPreview();   // instant thumbnail for the ready card
    var blob;
    try { blob = captureAdditions(); } catch (e) { blob = null; }
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (publicId) {
      var urls = buildPhoneUrls(publicId);
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), localPreview, urls.preview, urls.print, true);
      done(); close();
    }).catch(function () {
      alert('Could not save your design — please check your connection and try again.');
      done();
    });
  }
  // Flat pipeline (clothing/drinkware): capture the whole artboard as ONE artwork → upload →
  // composite onto the garment/drinkware via the product recipe (l_<artwork> in the c_fit box).
  function finishFlat(btn) {
    if (btn) btn.classList.add('is-busy');
    var localPreview = exportPreview();
    var blob;
    try { blob = captureArtboard(); } catch (e) { blob = null; }
    loading(true, 'Saving your design…');
    var done = function () { if (btn) btn.classList.remove('is-busy'); loading(false); };
    if (!blob) { alert('Could not save your design. Please try again.'); done(); return; }
    uploadAdditions(blob).then(function (publicId) {
      var CL = 'https://res.cloudinary.com/' + CFG.cloudName + '/';
      var previewUrl = flatEntry && flatEntry.preview
        ? CL + 'image/upload/' + flatEntry.preview.replace('{ARTWORK}', publicId)
        : CL + 'image/upload/' + publicId;
      var printUrl = CL + 'image/upload/' + publicId;   // the flat artwork IS the print file
      markReady(document.querySelector(CFG.productFormSelector || '[data-pdp-form]'), localPreview, previewUrl, printUrl);
      done(); close();
    }).catch(function () {
      alert('Could not save your design — please check your connection and try again.');
      done();
    });
  }
  // Wipe an unsaved design (used when the shopper changes variant before adding to bag).
  function clearDesign() {
    designAttached = false;
    var form = document.querySelector(CFG.productFormSelector || '[data-pdp-form]');
    if (form) {
      ['preview', 'print'].forEach(function (mk) { var i = form.querySelector('input[data-pz-file-marker="' + mk + '"]'); if (i) i.remove(); });
      ['_Your design', 'Your design', '_Print file', '_Personalised', 'Print file (test)'].forEach(function (n) {
        var el = form.querySelector('input[name="properties[' + n + ']"]'); if (el) el.remove();
      });
    }
    var thumb = document.querySelector('[data-pz-preview]');
    if (thumb) { thumb.hidden = true; thumb.innerHTML = ''; }
    var trigger = document.querySelector('.pz-open[data-pz-open]');
    if (trigger) trigger.hidden = false;
    restorePdp();   // put the normal product image back
    // Reset the canvas so the next open starts fresh for the new variant.
    if (fcanvas) {
      fcanvas.getObjects().slice().forEach(function (o) { if (!o._pzGuide) fcanvas.remove(o); });
      baseLoaded = false; history = []; histIdx = -1; fcanvas.requestRenderAll();
    }
    emitChange();
  }
  // Themed "you'll lose your design" confirm. onProceed() runs only if the shopper agrees.
  function confirmReset(onProceed) {
    var ov = document.createElement('div');
    ov.className = 'pz-confirm';
    ov.innerHTML = '<div class="pz-confirm__card">' +
      '<div class="pz-confirm__ico">⚠️</div>' +
      '<h3>Change without saving?</h3>' +
      '<p>You\'ve personalised this item but haven\'t added it to your bag yet. Changing your phone or options now will <b>clear your design</b>.</p>' +
      '<div class="pz-confirm__btns">' +
        '<button type="button" class="pz-confirm__keep" data-pz-keep>Keep my design</button>' +
        '<button type="button" class="pz-confirm__go" data-pz-go>Discard &amp; change</button>' +
      '</div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-go]')) { ov.remove(); clearDesign(); if (onProceed) onProceed(); return; }
      if (e.target.closest('[data-pz-keep]') || e.target === ov) { ov.remove(); return; }
    });
  }
  function setHidden(form, name, val) {
    var sel = 'input[name="properties[' + name + ']"]';
    var el = form.querySelector(sel);
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'properties[' + name + ']'; form.appendChild(el); }
    el.value = val;
  }

  /* ---------- boot ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pz-remove]')) { e.preventDefault(); clearDesign(); return; }
    if (e.target.closest('[data-pz-open]')) { e.preventDefault(); open(); }
  });

  // Exposed so the PDP variant/model pickers can warn before wiping an unsaved design.
  window.FCPz = {
    hasDesign: function () { return designAttached; },
    clearDesign: clearDesign,
    confirmReset: confirmReset
  };
})();

